import { FC } from 'react';
import { YoutubeScenario } from 'src/types/domain';
import * as S from './styles';

type LearnablesProps = {
  learnables: YoutubeScenario['learnables'];
} & S.StyleProps;

const Learnables: FC<LearnablesProps> = ({ learnables, ...rest }) => {
  return (
    <S.Learnables {...rest}>
      {learnables.map(({ sourceValue, targetValue }) => {
        return (
          <S.Learnable key={targetValue}>
            <S.Target>{targetValue}</S.Target>
            <S.Source>{sourceValue}</S.Source>
          </S.Learnable>
        );
      })}
    </S.Learnables>
  );
};

export default Learnables;
